import Script from 'next/script'
import { useTranslation } from 'next-i18next'
import 'twin.macro'
import { useTrackStoreInternalSearch } from 'gtm-analytics/tracking/eventHooks'
import storeRocketStyle from './styles'
import type { StoreRocketProps } from './types'

const StoreRocket = (props: StoreRocketProps) => {
  const { accountId, lang, filters } = props
  const { t } = useTranslation('common')

  useTrackStoreInternalSearch()

  if (!accountId) return <>Please add an account ID</>

  return (
    <div tw="min-h-[900px] h-[calc(100vh/1.5)]">
      <div className="storerocket-widget" tw="h-full" css={storeRocketStyle}>
        <p>{t('LOCATIONSTORE.LOADING')}</p>
      </div>
      <Script
        src="//cdn.storerocket.io/widget.js"
        onLoad={() => {
          const config = {
            selector: '.storerocket-widget',
            account: accountId,
            lang,
            filters,
          }
          window.StoreRocket.init(config)
        }}
      />
    </div>
  )
}

export default StoreRocket
